import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconCheckCircle: FC<IconProps> = ({ $size, ...rest }) => {
  return (
    <IconNonFilledStyled {...{ $size, ...rest }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="16" fill="white" />
        <path
          d="M21.5 13L14.1625 20L10.5 16.5"
          stroke={colors[rest?.$color]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
          stroke={colors[rest?.$color]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconNonFilledStyled>
  );
};

IconCheckCircle.defaultProps = iconDefaultProps;
IconCheckCircle.displayName = 'IconCheckCircle';

export default IconCheckCircle;
